module.exports = __webpack_public_path__ + "images/erp-nation-glad-bottom.1792157180594.png";